module.exports = __webpack_public_path__ + "img/vip-icon-4.0a1945d9.png";